(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hazel-sticky-atc"] && !Shopify.designMode) return;
  try {
    class HazelStickyAtc extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('[data-hazel-submit]');
      this.priceEl = this.querySelector('[data-hazel-price]');

      this.target = document.querySelector('#ProductSubmitButton-' + this.sectionId);
      if (!this.target) {
        const section = document.querySelector('#shopify-section-' + this.sectionId);
        if (section) this.target = section.querySelector('product-form button[name="add"]');
      }
      if (!this.target) return;

      this.hidden = false;
      this.syncState();

      this.button.addEventListener('click', () => {
        if (this.mode === 'choose') {
          const picker = document.querySelector('variant-selects, variant-radios');
          (picker || this.target).scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.target.click();
      });

      // position is re-checked on every scroll frame: an IntersectionObserver
      // with threshold 0 never fires when an instant jump (anchor link,
      // back/forward restore, scrollTo) skips the intersection entirely.
      this.ticking = false;
      this.checkVisibility = () => {
        this.ticking = false;
        const rect = this.target.getBoundingClientRect();
        const notReached = rect.top > window.innerHeight;
        const scrolledPast = rect.bottom < 0;
        const mode = notReached ? 'choose' : 'add';
        if (mode !== this.mode) {
          this.mode = mode;
          this.syncState();
        }
        this.classList.toggle('hazel-sticky--visible', notReached || scrolledPast);
      };
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(this.checkVisibility);
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.checkVisibility();

      this.stateObserver = new MutationObserver(() => this.syncState());
      this.stateObserver.observe(this.target, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
      });

      const livePrice = document.querySelector('#price-' + this.sectionId);
      if (livePrice) {
        this.priceObserver = new MutationObserver(() => this.syncPrice(livePrice));
        this.priceObserver.observe(livePrice, { childList: true, subtree: true, characterData: true });
        this.syncPrice(livePrice);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.stateObserver) this.stateObserver.disconnect();
      if (this.priceObserver) this.priceObserver.disconnect();
    }

    syncState() {
      if (this.mode === 'choose') {
        this.button.disabled = false;
        this.button.textContent = this.dataset.chooseLabel;
        return;
      }
      const disabled = this.target.hasAttribute('disabled');
      this.button.disabled = disabled;
      const label = this.target.querySelector('span');
      if (label && label.textContent.trim()) {
        this.button.textContent = label.textContent.trim();
      }
    }

    syncPrice(livePrice) {
      const regular = livePrice.querySelector('.price-item--regular');
      const sale = livePrice.querySelector('.price-item--sale');
      const current = sale || regular;
      if (current && current.textContent.trim()) {
        this.priceEl.textContent = current.textContent.trim();
      }
    }
  }

  if (!customElements.get('hazel-sticky-atc')) {
    customElements.define('hazel-sticky-atc', HazelStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
